import React from "react";
import { Websocket, WebsocketBuilder } from "websocket-ts/lib";
import { cst } from "../utils/constants";

export const notificationsWebSocketUrl = cst.webSocketUrl + "/notifications/websocket";

export const NotificationWebSocketContext = React.createContext<Websocket>(
  new WebsocketBuilder(notificationsWebSocketUrl).build()
);
